export const validationCodeNumber = (number, codes) => {
  const cleanedNumber = number.replace(/\D/g, '')
  const prefix = cleanedNumber.substring(0, 2)

  return codes.includes(prefix)
}

export const validationNulls = (number) => {
  // before 0 | after 0000
  const regex = /^(?!0)\d{9,10}(?!0000)$/
  return regex.test(number) && !number.endsWith('0000')
}
